import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function ContactSection() {
  const {
    t
  } = useLanguage();
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    interest: t.contact.defaultInterest,
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Visual only - no actual submission
    alert(t.contact.alertMsg);
    setFormState({
      name: '',
      email: '',
      interest: t.contact.defaultInterest,
      message: ''
    });
  };
  return <section id="kontakt" className="py-24 md:py-32 bg-charcoal-900 relative bg-grain" data-id="element-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-14">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-15">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading text-cream mb-8" data-id="element-16">
              {t.contact.heading1} <br data-id="element-17" />
              <span className="italic text-gold" data-id="element-18">{t.contact.heading2}</span>
            </h2>
            <p className="text-lg text-cream/70 font-light leading-relaxed mb-12 max-w-md" data-id="element-19">
              {t.contact.desc}
            </p>

            <div className="space-y-8" data-id="element-20">
              <div data-id="element-21">
                <span className="block text-sm tracking-[0.2em] uppercase text-gold font-semibold mb-2" data-id="element-22">
                  {t.contact.addressLabel}
                </span>
                <p className="text-xl text-cream font-light" data-id="element-23">
                  Malostranská 38/24 118 00 Praha 1
                </p>
              </div>
              <div data-id="element-24">
                <span className="block text-sm tracking-[0.2em] uppercase text-gold font-semibold mb-2" data-id="element-25">
                  {t.contact.phoneLabel}
                </span>
                <a href="tel:+420774110007" className="text-xl text-cream font-light hover:text-gold transition-colors" data-id="element-26">
                  +420 603 238 888
                </a>
              </div>
              <div data-id="element-27">
                <span className="block text-sm tracking-[0.2em] uppercase text-gold font-semibold mb-2" data-id="element-28">
                  {t.contact.emailLabel}
                </span>
                <a href="mailto:info@malostranska.com" className="text-xl text-cream font-light hover:text-gold transition-colors" data-id="element-29">
                  kasspi@gmail.com
                </a>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-charcoal-800 p-8 md:p-12 border border-charcoal-700" data-id="element-30">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-31">
              <div data-id="element-32">
                <label htmlFor="name" className="block text-sm tracking-widest uppercase text-cream/70 mb-2" data-id="element-33">
                  {t.contact.formLabels.name}
                </label>
                <input type="text" id="name" required value={formState.name} onChange={e => setFormState({
                ...formState,
                name: e.target.value
              })} className="w-full bg-charcoal-900 border-b border-charcoal-600 px-4 py-3 text-cream focus:outline-none focus:border-gold transition-colors font-light" placeholder={t.contact.formPlaceholders.name} data-id="element-34" />
              </div>

              <div data-id="element-35">
                <label htmlFor="email" className="block text-sm tracking-widest uppercase text-cream/70 mb-2" data-id="element-36">
                  {t.contact.formLabels.email}
                </label>
                <input type="email" id="email" required value={formState.email} onChange={e => setFormState({
                ...formState,
                email: e.target.value
              })} className="w-full bg-charcoal-900 border-b border-charcoal-600 px-4 py-3 text-cream focus:outline-none focus:border-gold transition-colors font-light" placeholder={t.contact.formPlaceholders.email} data-id="element-37" />
              </div>

              <div data-id="element-38">
                <label htmlFor="interest" className="block text-sm tracking-widest uppercase text-cream/70 mb-2" data-id="element-39">
                  {t.contact.formLabels.interest}
                </label>
                <select id="interest" value={formState.interest} onChange={e => setFormState({
                ...formState,
                interest: e.target.value
              })} className="w-full bg-charcoal-900 border-b border-charcoal-600 px-4 py-3 text-cream focus:outline-none focus:border-gold transition-colors font-light appearance-none" data-id="element-40">
                  <option value={t.contact.selectOptions.sale} data-id="element-41">
                    {t.contact.selectOptions.sale}
                  </option>
                  <option value={t.contact.selectOptions.rental} data-id="element-42">
                    {t.contact.selectOptions.rental}
                  </option>
                  <option value={t.contact.selectOptions.other} data-id="element-43">
                    {t.contact.selectOptions.other}
                  </option>
                </select>
              </div>

              <div data-id="element-44">
                <label htmlFor="message" className="block text-sm tracking-widest uppercase text-cream/70 mb-2" data-id="element-45">
                  {t.contact.formLabels.message}
                </label>
                <textarea id="message" required rows={4} value={formState.message} onChange={e => setFormState({
                ...formState,
                message: e.target.value
              })} className="w-full bg-charcoal-900 border-b border-charcoal-600 px-4 py-3 text-cream focus:outline-none focus:border-gold transition-colors font-light resize-none" placeholder={t.contact.formPlaceholders.message} data-id="element-46"></textarea>
              </div>

              <button type="submit" className="w-full px-8 py-4 bg-gold text-charcoal-900 text-sm tracking-widest uppercase font-semibold hover:bg-gold-hover transition-colors duration-300 mt-4" data-id="element-47">
                {t.contact.submitBtn}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}